export default "__VITE_ASSET__1ccd8129__"